import React, { useState } from 'react';
import { useBusiness } from '../contexts/BusinessContext';
import { useAuth } from '../contexts/AuthContext';

// Icons (replacing Material UI icons)
const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
  </svg>
);

const AddIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
  </svg>
);

const MoreVertIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
  </svg>
);

const EditIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
  </svg>
);

const DeleteIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
  </svg>
);

const BlockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z" clipRule="evenodd" />
  </svg>
);

const KeyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clipRule="evenodd" />
  </svg>
);

const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
  </svg>
);

const FilterIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
  </svg>
);

// Mock user data
const MOCK_USERS = [
  {
    id: 'u1',
    name: 'John Doe',
    email: 'john@example.com',
    role: 'owner',
    status: 'active',
    lastLogin: '2023-06-09T15:32:00Z',
    createdAt: '2023-01-15T12:00:00Z'
  },
  {
    id: 'u2',
    name: 'Jane Smith',
    email: 'jane@example.com',
    role: 'manager',
    status: 'active',
    lastLogin: '2023-06-10T09:15:00Z',
    createdAt: '2023-02-20T14:30:00Z'
  },
  {
    id: 'u3',
    name: 'Bob Johnson',
    email: 'bob@example.com',
    role: 'staff',
    status: 'inactive',
    lastLogin: '2023-05-28T11:45:00Z',
    createdAt: '2023-03-10T09:00:00Z'
  },
  {
    id: 'u4',
    name: 'Sarah Williams',
    email: 'sarah@example.com',
    role: 'staff',
    status: 'active',
    lastLogin: '2023-06-10T11:20:00Z',
    createdAt: '2023-04-05T16:15:00Z'
  },
  {
    id: 'u5',
    name: 'Michael Brown',
    email: 'michael@example.com',
    role: 'staff',
    status: 'active',
    lastLogin: '2023-06-08T14:10:00Z',
    createdAt: '2023-04-15T10:30:00Z'
  },
  {
    id: 'u6',
    name: 'Emily Davis',
    email: 'emily@example.com',
    role: 'manager',
    status: 'active',
    lastLogin: '2023-06-09T16:45:00Z',
    createdAt: '2023-03-25T13:20:00Z'
  }
];

const ROLES = [
  { value: 'owner', label: 'Owner', description: 'Full access to all settings and features' },
  { value: 'manager', label: 'Manager', description: 'Can manage operations but not business settings' },
  { value: 'staff', label: 'Staff', description: 'Limited access to operations only' }
];

const UsersPage = () => {
  const { selectedBusiness } = useBusiness();
  const { isPlatformAdmin } = useAuth();
  
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filterRole, setFilterRole] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [roleMenuOpenFor, setRoleMenuOpenFor] = useState(null);
  const [roleMenuPosition, setRoleMenuPosition] = useState({ top: 0, left: 0 });
  
  // Form state for new user
  const [newUser, setNewUser] = useState({
    name: '',
    email: '',
    role: 'staff',
    sendInvite: true
  });
  
  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(0); // Reset to first page on new search
  };
  
  // Handle page change
  const handleChangePage = (newPage) => {
    setPage(newPage);
  };
  
  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  // Handle filter menu
  const handleToggleFilterMenu = () => {
    setFilterMenuOpen(!filterMenuOpen);
  };
  
  // Handle role filter change
  const handleRoleFilterChange = (role) => {
    setFilterRole(role);
    setPage(0);
    setFilterMenuOpen(false);
  };
  
  // Handle status filter change
  const handleStatusFilterChange = (status) => {
    setFilterStatus(status);
    setPage(0);
    setFilterMenuOpen(false);
  };
  
  // Handle action menu
  const handleOpenActionMenu = (event, user) => {
    event.preventDefault();
    const rect = event.currentTarget.getBoundingClientRect();
    setMenuPosition({ 
      top: rect.bottom + window.scrollY, 
      left: rect.left + window.scrollX - 100 // Adjust menu position to show on left side
    });
    setSelectedUser(user);
    setMenuOpen(true);
  };
  
  const handleCloseActionMenu = () => {
    setMenuOpen(false);
  };
  
  // Handle role menu
  const handleRoleMenuOpen = (event, index) => {
    event.preventDefault();
    const rect = event.currentTarget.getBoundingClientRect();
    setRoleMenuPosition({
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX
    });
    setRoleMenuOpenFor(index);
  };
  
  const handleRoleMenuClose = () => {
    setRoleMenuOpenFor(null);
  };
  
  // Handle dialog open/close
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setNewUser({
      name: '',
      email: '',
      role: 'staff',
      sendInvite: true
    });
  };
  
  // Handle form change for new user
  const handleNewUserChange = (e) => {
    const { name, type, checked, value } = e.target;
    setNewUser(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  
  // Handle invite user submission
  const handleInviteUser = () => {
    // In a real app, send to API
    // For demo, just close the dialog
    handleCloseDialog();
  };
  
  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };
  
  // Get role label
  const getRoleLabel = (roleValue) => {
    const role = ROLES.find(r => r.value === roleValue);
    return role ? role.label : roleValue;
  };
  
  // Get role color
  const getRoleColor = (role) => {
    switch (role) {
      case 'owner':
        return 'bg-primary-500 text-white';
      case 'manager':
        return 'bg-accent-500 text-white';
      case 'staff':
        return 'bg-dark-500 text-gray-300';
      default:
        return 'bg-dark-500 text-gray-300';
    }
  };
  
  const getRoleOutlineColor = (role) => {
    switch (role) {
      case 'owner':
        return 'border-primary-500 text-primary-500';
      case 'manager':
        return 'border-accent-500 text-accent-500';
      case 'staff':
        return 'border-gray-500 text-gray-300';
      default:
        return 'border-gray-500 text-gray-300';
    }
  };
  
  // Get status color
  const getStatusColor = (status) => {
    return status === 'active' 
      ? 'bg-green-800 text-green-200' 
      : 'bg-red-900 text-red-200';
  };
  
  const getStatusOutlineColor = (status) => {
    return status === 'active' 
      ? 'border-green-600 text-green-500' 
      : 'border-red-600 text-red-500';
  };
  
  // Filter users based on search term and filters
  const filteredUsers = MOCK_USERS
    .filter(user => 
      (user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
       user.email.toLowerCase().includes(searchTerm.toLowerCase())) &&
      (filterRole === 'all' || user.role === filterRole) &&
      (filterStatus === 'all' || user.status === filterStatus)
    );
  
  // Get users for current page
  const paginatedUsers = filteredUsers
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  
  // Generate name initials for avatar
  const getInitials = (name) => {
    return name
      .split(' ')
      .map(part => part.charAt(0))
      .join('')
      .toUpperCase();
  };
  
  // Calculate pagination numbers
  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
  const startIndex = page * rowsPerPage + 1;
  const endIndex = Math.min((page + 1) * rowsPerPage, filteredUsers.length);
  
  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl font-bold text-white">
          Users & Permissions
        </h1>
        
        <button
          className="btn-primary inline-flex items-center"
          onClick={handleOpenDialog}
        >
          <AddIcon />
          <span className="ml-2">Invite User</span>
        </button>
      </div>
      
      {selectedBusiness && (
        <p className="text-gray-400 mb-6">
          Manage users for {selectedBusiness.name || 'your business'}
        </p>
      )}
      
      <div className="card mb-6">
        <div className="p-4 flex items-center gap-4">
          <div className="relative flex-grow">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-400">
              <SearchIcon />
            </div>
            <input
              type="text"
              className="form-input pl-10"
              placeholder="Search users..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
          
          <div className="relative">
            <button
              className="btn-secondary inline-flex items-center"
              onClick={handleToggleFilterMenu}
            >
              <FilterIcon />
              <span className="ml-2">Filters</span>
            </button>
            
            {filterMenuOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-dark-700 border border-dark-600 rounded-md shadow-lg z-10">
                <div className="px-4 py-2 text-xs text-gray-400 border-b border-dark-600">
                  Role
                </div>
                <button
                  className={`w-full text-left px-4 py-2 text-sm ${
                    filterRole === 'all' ? 'bg-dark-600' : 'hover:bg-dark-600'
                  }`}
                  onClick={() => handleRoleFilterChange('all')}
                >
                  All Roles
                </button>
                {ROLES.map(role => (
                  <button
                    key={role.value}
                    className={`w-full text-left px-4 py-2 text-sm ${
                      filterRole === role.value ? 'bg-dark-600' : 'hover:bg-dark-600'
                    }`}
                    onClick={() => handleRoleFilterChange(role.value)}
                  >
                    {role.label}
                  </button>
                ))}
                
                <div className="px-4 py-2 text-xs text-gray-400 border-t border-b border-dark-600 mt-1">
                  Status
                </div>
                <button
                  className={`w-full text-left px-4 py-2 text-sm ${
                    filterStatus === 'all' ? 'bg-dark-600' : 'hover:bg-dark-600'
                  }`}
                  onClick={() => handleStatusFilterChange('all')}
                >
                  All Statuses
                </button>
                <button
                  className={`w-full text-left px-4 py-2 text-sm ${
                    filterStatus === 'active' ? 'bg-dark-600' : 'hover:bg-dark-600'
                  }`}
                  onClick={() => handleStatusFilterChange('active')}
                >
                  Active
                </button>
                <button
                  className={`w-full text-left px-4 py-2 text-sm ${
                    filterStatus === 'inactive' ? 'bg-dark-600' : 'hover:bg-dark-600'
                  }`}
                  onClick={() => handleStatusFilterChange('inactive')}
                >
                  Inactive
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      
      <div className="bg-dark-700 border border-dark-600 rounded-md overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-dark-600">
            <thead className="bg-dark-800">
              <tr>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                  User
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                  Role
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                  Last Login
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">
                  Added On
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-400 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-dark-600">
              {paginatedUsers.length > 0 ? (
                paginatedUsers.map((user, index) => (
                  <tr key={user.id} className="hover:bg-dark-600">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-10 w-10 rounded-full bg-primary-700 flex items-center justify-center text-white font-medium">
                          {getInitials(user.name)}
                        </div>
                        <div className="ml-4">
                          <div className="font-medium text-white">
                            {user.name}
                          </div>
                          <div className="text-sm text-gray-400">
                            {user.email}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="relative">
                        <span 
                          id={`role-chip-${index}`}
                          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                            user.role === 'owner' 
                              ? getRoleColor(user.role) 
                              : 'border ' + getRoleOutlineColor(user.role)
                          } ${(isPlatformAdmin || user.role !== 'owner') ? 'cursor-pointer' : ''}`}
                          onClick={(e) => (isPlatformAdmin || user.role !== 'owner') && handleRoleMenuOpen(e, index)}
                        >
                          {getRoleLabel(user.role)}
                        </span>
                        
                        {roleMenuOpenFor === index && (
                          <div 
                            className="absolute left-0 mt-1 w-64 bg-dark-700 rounded-md shadow-lg z-20 border border-dark-600"
                            style={{ top: roleMenuPosition.top, left: roleMenuPosition.left }}
                          >
                            <ul className="py-1">
                              {ROLES.map(role => (
                                <li 
                                  key={role.value}
                                  className={`px-4 py-2 hover:bg-dark-600 ${
                                    role.value === 'owner' && !isPlatformAdmin 
                                      ? 'opacity-50 cursor-not-allowed' 
                                      : 'cursor-pointer'
                                  } ${user.role === role.value ? 'bg-dark-600' : ''}`}
                                  onClick={() => role.value !== 'owner' || isPlatformAdmin ? handleRoleMenuClose() : null}
                                >
                                  <div className="font-medium text-white">{role.label}</div>
                                  <div className="text-xs text-gray-400">{role.description}</div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        user.status === 'active' 
                          ? getStatusColor(user.status) 
                          : 'border ' + getStatusOutlineColor(user.status)
                      }`}>
                        {user.status.charAt(0).toUpperCase() + user.status.slice(1)}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300">
                      {formatDate(user.lastLogin)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-300">
                      {formatDate(user.createdAt)}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right">
                      <button
                        className="text-gray-400 hover:text-white"
                        onClick={(e) => handleOpenActionMenu(e, user)}
                      >
                        <MoreVertIcon />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="px-6 py-12 text-center">
                    <p className="text-lg font-medium mb-2">
                      No users found
                    </p>
                    <p className="text-gray-400">
                      {searchTerm || filterRole !== 'all' || filterStatus !== 'all' ? 
                        'Try adjusting your search or filters' : 
                        'Add users to your business by clicking "Invite User"'
                      }
                    </p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        
        <div className="bg-dark-800 px-4 py-3 flex items-center justify-between sm:px-6">
          <div className="flex-1 flex justify-between sm:hidden">
            <button
              className="btn-secondary"
              onClick={() => handleChangePage(page - 1)}
              disabled={page === 0}
            >
              Previous
            </button>
            <button
              className="btn-secondary"
              onClick={() => handleChangePage(page + 1)}
              disabled={page >= totalPages - 1}
            >
              Next
            </button>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
            <div>
              <p className="text-sm text-gray-400">
                Showing <span className="font-medium">{startIndex}</span> to <span className="font-medium">{endIndex}</span> of{' '}
                <span className="font-medium">{filteredUsers.length}</span> results
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-sm text-gray-400">Rows per page:</span>
              <select
                className="form-input py-1 pl-2 pr-8 text-sm"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
              >
                {[5, 10, 25].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
              
              <nav className="relative z-0 inline-flex -space-x-px">
                <button
                  className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-dark-600 bg-dark-700 text-sm font-medium text-gray-300 hover:bg-dark-600"
                  onClick={() => handleChangePage(page - 1)}
                  disabled={page === 0}
                >
                  <span className="sr-only">Previous</span>
                  <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </button>
                
                <button
                  className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-dark-600 bg-dark-700 text-sm font-medium text-gray-300 hover:bg-dark-600"
                  onClick={() => handleChangePage(page + 1)}
                  disabled={page >= totalPages - 1}
                >
                  <span className="sr-only">Next</span>
                  <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                  </svg>
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
      
      {/* Action Menu */}
      {menuOpen && (
        <div 
          className="fixed inset-0 z-50"
          onClick={handleCloseActionMenu}
        >
          <div 
            className="absolute bg-dark-700 border border-dark-600 rounded-md shadow-lg"
            style={{ top: menuPosition.top, left: menuPosition.left }}
            onClick={e => e.stopPropagation()}
          >
            <ul className="py-1">
              <li 
                className="px-4 py-2 text-sm text-gray-300 hover:bg-dark-600 flex items-center cursor-pointer"
                onClick={handleCloseActionMenu}
              >
                <EditIcon className="mr-3 text-gray-400" />
                <span>Edit User</span>
              </li>
              <li 
                className="px-4 py-2 text-sm text-gray-300 hover:bg-dark-600 flex items-center cursor-pointer"
                onClick={handleCloseActionMenu}
              >
                <KeyIcon className="mr-3 text-gray-400" />
                <span>Reset Password</span>
              </li>
              <li 
                className="px-4 py-2 text-sm text-gray-300 hover:bg-dark-600 flex items-center cursor-pointer"
                onClick={handleCloseActionMenu}
              >
                <MailIcon className="mr-3 text-gray-400" />
                <span>Resend Invitation</span>
              </li>
              <li 
                className="px-4 py-2 text-sm text-red-400 hover:bg-dark-600 flex items-center cursor-pointer"
                onClick={handleCloseActionMenu}
              >
                <BlockIcon className="mr-3 text-red-400" />
                <span>
                  {selectedUser?.status === 'active' ? 'Deactivate User' : 'Activate User'}
                </span>
              </li>
              <li 
                className="px-4 py-2 text-sm text-red-400 hover:bg-dark-600 flex items-center cursor-pointer"
                onClick={handleCloseActionMenu}
              >
                <DeleteIcon className="mr-3 text-red-400" />
                <span>Delete User</span>
              </li>
            </ul>
          </div>
        </div>
      )}
      
      {/* Invite User Dialog */}
      {openDialog && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="fixed inset-0 bg-black bg-opacity-50" onClick={handleCloseDialog}></div>
          <div className="bg-dark-700 rounded-lg shadow-xl w-full max-w-md mx-4 z-10 border border-dark-600">
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-4">Invite User</h2>
              
              <div className="space-y-4">
                <div>
                  <label className="form-label" htmlFor="name">Name</label>
                  <input
                    id="name"
                    type="text"
                    className="form-input"
                    name="name"
                    value={newUser.name}
                    onChange={handleNewUserChange}
                    required
                  />
                </div>
                
                <div>
                  <label className="form-label" htmlFor="email">Email</label>
                  <input
                    id="email"
                    type="email"
                    className="form-input"
                    name="email"
                    value={newUser.email}
                    onChange={handleNewUserChange}
                    required
                  />
                </div>
                
                <div>
                  <label className="form-label" htmlFor="role">Role</label>
                  <select
                    id="role"
                    className="form-input"
                    name="role"
                    value={newUser.role}
                    onChange={handleNewUserChange}
                    required
                  >
                    {ROLES.map(role => (
                      <option 
                        key={role.value} 
                        value={role.value}
                        disabled={role.value === 'owner' && !isPlatformAdmin}
                      >
                        {role.label} - {role.description}
                      </option>
                    ))}
                  </select>
                </div>
                
                <div className="flex items-center">
                  <label className="inline-flex items-center cursor-pointer">
                    <input 
                      type="checkbox" 
                      className="sr-only peer"
                      name="sendInvite"
                      checked={newUser.sendInvite}
                      onChange={handleNewUserChange}
                    />
                    <div className="relative w-11 h-6 bg-dark-500 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary-500 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600"></div>
                    <span className="ml-3 text-sm font-medium text-gray-300">
                      Send invitation email
                    </span>
                  </label>
                </div>
              </div>
              
              <div className="flex justify-end mt-6 space-x-2">
                <button 
                  className="btn-secondary"
                  onClick={handleCloseDialog}
                >
                  Cancel
                </button>
                <button 
                  className="btn-primary"
                  onClick={handleInviteUser}
                  disabled={!newUser.name || !newUser.email}
                >
                  Invite User
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsersPage;